import React from "react";
import { getRuntimeEnvironment } from "../../services/local/runtimeEnvironment";
import "../../styles/MerchantApkDownload.css";

export const MERCHANT_BETA_APK_URL =
  "https://beta.mozzoapp.com/downloads/we-pedidos-comercios-beta-1.0.0.apk";

export default function MerchantApkDownload() {
  const userAgent = typeof navigator === "undefined" ? "" : navigator.userAgent;
  const insideMerchantApp = /(?:^|\s)MozzoWeComercios\/[\d.]+/i.test(userAgent);
  if (getRuntimeEnvironment() !== "beta" || insideMerchantApp) return null;

  return (
    <aside className="merchant-apk-download" aria-label="App de Comercios para Android">
      <div className="merchant-apk-download__copy">
        <strong>We!Pedidos Comercios en tu celular</strong>
        <p>Version beta para Android 8 o superior. Usa tu misma cuenta de beta.</p>
      </div>
      <a
        className="merchant-apk-download__button"
        href={MERCHANT_BETA_APK_URL}
        download="WePedidos-Comercios-beta-1.0.0.apk"
      >
        Descargar APK para Android
      </a>
    </aside>
  );
}
